import { render, staticRenderFns } from "./QuestionHinshiOptions.vue?vue&type=template&id=09c8d172&scoped=true"
import script from "./QuestionHinshiOptions.vue?vue&type=script&lang=js"
export * from "./QuestionHinshiOptions.vue?vue&type=script&lang=js"
import style0 from "./QuestionHinshiOptions.vue?vue&type=style&index=0&id=09c8d172&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8d172",
  null
  
)

export default component.exports